import { createContext } from "react";
import { MappedEvent } from "@data-types/results";

export const ResultsEventContext = createContext({} as MappedEvent);
